import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=1eee4d5f"
import script from "./AddProfile.vue?vue&type=script&lang=js"
export * from "./AddProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports